import { cn } from '@/lib/utils'
import ResponsiveImage from '@/v2/components/helpers/responsive-image'
import SectionHead from '@/v2/components/sections/landing-pages/section-head'
import SectionWrapper from '@/v2/components/wrappers/section-wrapper'
import { CardType } from '@/v2/types/cards'
import { domAnimation, LazyMotion, m } from 'framer-motion'
import React from 'react'

interface PartnersSectionProps {
  title: string
  description?: string
  cards: CardType[]
  className?: string
  isBgDark?: boolean
}

const PartnersSection: React.FC<PartnersSectionProps> = props => {
  const { title, description, cards, className, isBgDark = false } = props

  return (
    <LazyMotion features={domAnimation}>
      <m.section className={cn('landing-pages-wr section-spacing', isBgDark ? 'bg-[#F9F8F8]' : '', className)}>
        <SectionWrapper>
          <SectionHead title={title} description={description} />

          <div className={cn('flex items-center gap-[24px] xl-min:gap-[50px] text-center md-mn:flex-nowrap flex-wrap')}>
            {cards.map((card, index) => (
              <m.article
                key={card.id}
                className='flex flex-col items-center py-5 px-2 [&>h3]:text-paragraph 
                [&>h3]:font-semibold xl-min:[&>h3]:text-xl [&>h3]:w-full [&>h3]:text-lg [&>h3]:mb-3 [&>h3]:mt-5 transition-all h-full'
                initial='hidden'
                whileInView='visible'
                viewport={{ once: false, amount: 0.3 }}
                transition={{
                  delay: index * 0.1,
                  duration: 0.6
                }}
              >
                {card.image && (
                  <div className='mb-auto'>
                    <ResponsiveImage
                      src={card.image.src}
                      alt={card.image.alt}
                      className={cn(
                        'lg-mn:h-[117px] lg-mn:w-[254px]  md-mn:w-[211px] md-mn:h-[97px] h-[117px] w-[254px]'
                      )}
                    />
                  </div>
                )}

                <h3>{card.title}</h3>
                <p className='text-paragraph leading-6 font-normal text-base mt-auto'>{card.description}</p>
              </m.article>
            ))}
          </div>
        </SectionWrapper>
      </m.section>
    </LazyMotion>
  )
}

export default PartnersSection
